<template>
  <div id="wrapper">
    <div id="main" class="clearfix">
      <Header />
      <div id="content">
        <homePage />
      </div>
      <div style="margin-top: 70px">
        <Footer />
      </div>

      <RightBar />
    </div>
  </div>
</template>
<script setup>

import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import RightBar from "../components/RightBar.vue";
import homePage from "./homeContent.vue";

</script>
<style>
:root {
  --font-size-small: 12px;
  --font-size-medium: 16px;
  --font-size-large: 20px;
  --current-font-size: var(--font-size-medium);
  /* 默认字号 */
}
</style>
